import store from '@/store'
import router from '@/router'
const disableClick = (event) => event && event.stopImmediatePropagation()
const auth = {
  inserted (el, binding, vnode) {
    /**
     * el: 指令所绑定的元素，可以用来直接操作DOM。
     * binding: 一个对象，包含指令的很多信息。
     * vnode: Vue编译生成的虚拟节点。
     */
    // 获取权限字段
    const { value } = binding
    /**
     * 可以以字符串形式传入code v-auth="'edit'"
     * 可以以数组形式传入code v-auth="['edit', 其他 disabled 条件]"
     * 如果以数组形式传入，数组第二个参数可以传递其他禁用条件，true 为禁用，此时及时有权限也会禁用
     */
    // 判断是否为数组
    let code = ''
    let isDisabled = false
    if (typeof value === 'string') {
      code = value
    } else if (Object.prototype.toString.call(value).slice(8, -1) === 'Array') {
      const [currentCode, currentDisabled] = value
      code = currentCode
      isDisabled = currentDisabled
    }
    // 获取当前路由下的权限字段
    const role = router.app._route.meta.roles[0]
    // 获取当前角色 当前路由下按钮权限列表
    let btnList = store.getters.authority[role] || []
    if (process.env.NODE_ENV === 'development') {
      btnList.push('test')
    }
    btnList = [...new Set(btnList)]
    // 如果没有权限，将按钮隐藏
    /**
     * 如果按钮权限有该权限，并且没有其他禁用条件 启用
     * 如果按钮权限有该权限，并且传入其他禁用条件 禁用
     * 如果按钮权限没有该权限，并且传入其他禁用条件 禁用
     * 如果按钮权限没有该权限，并且没有其他禁用条件 禁用
     */
    // 按钮权限是否为数组
    const isArray = Object.prototype.toString.call(btnList) === '[object Array]'
    if ((isArray && !btnList.includes(code)) || (isArray && btnList.includes(code) && isDisabled)) {
      el.style.cursor = 'not-allowed'
      el.style['user-select'] = 'none'
      el.setAttribute('disabled', true)
      // 禁用点击事件
      el.addEventListener('click', disableClick, true)
    }
  }
}
// 全局注册自定义指令
const install = function (Vue) {
  Vue.directive('auth', auth)
}

if (window.Vue) {
  window.auth = auth
  Vue.use(install); // eslint-disable-line
}

auth.install = install
export default auth
